<template>
    <div>
        <div
            v-if="areResultsLoading"
            class="spinner-container"
        >
            <SpinnerBars/>
        </div>
        <template v-else>
            <div class="matches-wrapper" v-if="activeSelections.length" >
                <div class="matches-status">
                    {{ $t('in play') }}
                </div>
                <div class="betslip-selection__item-wrapper">
                    <div
                        v-for="selection in activeSelections"
                        :key="selection.eventId"
                        class="betslip-selection__item"
                    >
                        <SelectionReadOnly v-bind="selection"/>
                    </div>
                </div>
            </div>
            <div class="matches-wrapper" v-if="resolvedSelections.length" >
                <div class="matches-status">
                    {{ $t('finished') }}
                </div>
                <div class="betslip-selection__item-wrapper">
                    <div
                        v-for="selection in resolvedSelections"
                        :key="selection.eventId"
                        class="betslip-selection__item"
                    >
                        <SelectionReadOnly v-bind="selection" />
                    </div>
                </div>
            </div>
            <div class="system-wrapper">
                <SystemRow
                    v-if="system"
                    v-bind="system"
                />
            </div>
        </template>
    </div>
</template>

<script>
    import { EventStatus } from '@core/models/tickets/enums';
    import SystemRow from '@modules/shared/tickets/SystemRow';
    import SelectionReadOnly from '@app/modules/shared/tickets/SelectionReadOnly';
    import { isSpecialEvent } from '@core/models/specials/SpecialEvent';
    import { createSportSelection, createSpecialSelection } from '@app/utils/mappers/TicketEventToSelectionProps';

    export default {
        props: {
            events: {
                type: Array,
                required: true,
            },
            areResultsLoading: {
                type: Boolean,
                required: true,
            },
            resultsMap: {
                type: Object,
                required: true,
            },
            system: {
                type: Object,
                default: null,
            },
        },
        computed: {
            activeSelections() {
                return this.selections.filter((selection) => selection.event.status === EventStatus.active);
            },
            resolvedSelections() {
                return this.selections.filter((selection) =>
                    selection.event.status === EventStatus.win
                    || selection.event.status === EventStatus.lost
                    || selection.event.status === EventStatus.refund);
            },
            selections() {
                return this.events.map((ticketEvent) => {
                    if (isSpecialEvent(ticketEvent.eventId)) {
                        return createSpecialSelection(ticketEvent);
                    }
                    const sportSelection = createSportSelection(ticketEvent);
                    const results = this.resultsMap[sportSelection.event.id];
                    sportSelection.event.result = results && results.result;

                    sportSelection.eventNo = ticketEvent.eventNo;
                    return sportSelection;
                });
            },
        },
        components: {
            SelectionReadOnly,
            SystemRow,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/tickets/components/sport/MatchesContainer.vue